import { render, staticRenderFns } from "./UnityOtherUGSConfig.vue?vue&type=template&id=0bbe7fda&scoped=true&"
import script from "./UnityOtherUGSConfig.vue?vue&type=script&lang=js&"
export * from "./UnityOtherUGSConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe7fda",
  null
  
)

export default component.exports